import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Einstellungen',
  lead: 'Ihr Unternehmensprofil, Ihre Corporate Identity und Ihre Datenschutzeinstellungen.',
  noCompany: 'Kein aktives Unternehmen ausgewählt.',
  adminOnly: 'Nur ein Plattform-Administrator kann dies ändern — Sie sehen die aktuellen Werte.',
  save: 'Speichern',
  nav: {
    label: 'Einstellungsmenü',
    profile: 'Profil',
    branding: 'Corporate Identity',
    privacy: 'Datenschutz',
    modules: 'Module',
  },
  profile: {
    title: 'Profil',
    name: 'Organisationsname',
    industry: 'Branche',
    industryHint: 'Freitext, z. B. „Logistik“ oder „Gesundheitswesen“.',
    employeeCount: 'Anzahl Mitarbeiter',
    plan: 'Abonnement',
    planPlaceholder: 'Siehe Abonnement',
  },
  branding: {
    title: 'Corporate Identity',
    lead: 'Ihr Logo und Ihre Akzentfarbe, wie sie in einer Live-Vorschau erscheinen.',
    logo: 'Logo hochladen',
    logoHint: 'Wird sofort hochgeladen, oder tragen Sie unten eine bestehende URL ein.',
    logoUrl: 'Logo-URL',
    upload: {
      uploading: 'Wird hochgeladen…',
      tooLarge: 'Datei ist zu groß (max. 10MB).',
      invalidType: 'Dateityp nicht zulässig.',
    },
    accentColor: 'Akzentfarbe',
    preview: 'Live-Vorschau',
    colors: {
      mint: 'Minze',
      pine: 'Tannengrün',
      ink: 'Schwarz',
      amber: 'Bernstein',
      coral: 'Koralle',
      sky: 'Himmelblau',
    },
  },
  privacy: {
    title: 'Datenschutz',
    lead: 'Die Mindestgruppengröße für aggregierte Statistiken und was Ihr Unternehmen teilt.',
    minGroupSize: 'Mindestgruppengröße (k-Anonymität)',
    minGroupSizeHint: 'Darunter ist eine Gruppe zu klein, um aggregierte Statistiken anzuzeigen.',
    minGroupSizeValue: '{{count}} Personen',
    effective: 'Derzeit gültig: {{count}} Personen',
    aggregatedData: 'Aggregierte Daten',
    aggregatedDataHint:
      'Aggregierte Statistiken für Gruppen anzeigen, die die Mindestgröße erreichen.',
    explicitConsent: 'Ausdrückliche Einwilligung erforderlich',
    explicitConsentHint:
      'Eine individuelle Einwilligung statt einer kollektiven Einwilligung verlangen.',
    dataExport: 'Datenexport',
    dataExportHint: 'Den Export von Statistikdaten erlauben.',
    auditLogHint: 'Administrative Aktionen werden immer in einem Auditprotokoll erfasst.',
  },
  modules: {
    title: 'Module',
    lead: 'Aktivieren oder deaktivieren Sie die für Ihr Unternehmen verfügbaren Module.',
    vitality: 'Vitalität',
    vitalityHint: 'Schlaf-, Stress-, Herzfrequenz- und Aktivitätserfassung.',
    participation: 'Partizipation',
    participationHint: 'Engagement-Funnel und Partizipationskennzahlen.',
    pilots: 'Pilotprojekte',
    pilotsHint: 'Führen Sie Pilotprogramme aus und verfolgen Sie diese.',
    challenges: 'Challenges',
    challengesHint: 'Erstellen und verwalten Sie Wellness-Challenges.',
    communication: 'Kommunikation',
    communicationHint: 'Senden Sie Benachrichtigungen und Nachrichten an Mitarbeiter.',
    documents: 'Dokumente',
    documentsHint: 'Veröffentlichen und verwalten Sie Unternehmensdokumente.',
    reports: 'Berichte',
    reportsHint: 'Generieren und exportieren Sie Analysisberichte.',
    ai_coach: 'KI-Coach',
    ai_coachHint: 'KI-gesteuerte personalisierte Coaching.',
  },
};
